import Freebies from "./Freebies";

export default Freebies;
